const getLanguageCode = (language) => language.toLowerCase().split('-')[0]

const createLocalBackend = (localeLoaders) => ({
  type: 'backend',
  read(language, _namespace, callback) {
    const languageCode = getLanguageCode(language)
    const localePath = `./localization/${languageCode}.json`
    const loadLocale = localeLoaders[localePath]

    if (!loadLocale) {
      callback(new Error(`Unsupported locale: ${languageCode}`), false)
      return
    }

    loadLocale()
      .then((localeModule) => {
        callback(null, localeModule.default || localeModule)
      })
      .catch((error) => {
        callback(error, false)
      })
  }
})

export default createLocalBackend
